import React from 'react'
import { I18n } from 'react-redux-i18n'

export default ({
  isShow,
  onHide,
  serviceTxn,
  on15MinExtendDurationClick,
  on30MinExtendDurationClick,
  on45MinExtendDurationClick,
  on60MinExtendDurationClick,
}) => {
  const timeFormat = I18n.t('date.timeFormat')

  if (!isShow) return null

  return (
    <div>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onHide}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900">Extend Duration</h2>
            <button
              onClick={onHide}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="px-6 py-4">
            <div className="space-y-3">
              {/* Passenger Name */}
              <div className="grid grid-cols-3 gap-4">
                <div className="text-sm font-medium text-gray-700">
                  Passenger Name
                </div>
                <div className="col-span-2 text-base text-gray-900">
                  {serviceTxn && serviceTxn.reservation.mainPax.fullName}
                </div>
              </div>

              {/* Service */}
              <div className="grid grid-cols-3 gap-4">
                <div className="text-sm font-medium text-gray-700">Service</div>
                <div className="col-span-2 text-base text-gray-900">
                  {serviceTxn &&
                    serviceTxn.service &&
                    `${serviceTxn.service.displayName}`}
                </div>
              </div>

              {/* In Time */}
              <div className="grid grid-cols-3 gap-4">
                <div className="text-sm font-medium text-gray-700">In Time</div>
                <div className="col-span-2 text-base text-gray-900">
                  {serviceTxn &&
                    serviceTxn.serviceInfo &&
                    serviceTxn.serviceInfo.inTime.format(timeFormat)}
                </div>
              </div>

              {/* Extended Hours */}
              <div className="grid grid-cols-3 gap-4">
                <div className="text-sm font-medium text-gray-700">
                  Extended Hours
                </div>
                <div className="col-span-2 text-base text-gray-900">
                  {serviceTxn &&
                  serviceTxn.serviceInfo &&
                  serviceTxn.serviceInfo.extraDuration
                    ? serviceTxn.serviceInfo.extraDuration
                    : 0}
                </div>
              </div>

              {/* Extended Time */}
              <div className="grid grid-cols-3 gap-4">
                <div className="text-sm font-medium text-gray-700">
                  Extended Time
                </div>
                <div className="col-span-2 text-base text-gray-900 underline font-semibold">
                  {serviceTxn &&
                    serviceTxn.serviceInfo &&
                    serviceTxn.serviceInfo.issuedOutTime.format(timeFormat)}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-center gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
            <button
              onClick={on15MinExtendDurationClick}
              className="px-4 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              15
            </button>
            <button
              onClick={on30MinExtendDurationClick}
              className="px-4 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              30
            </button>
            <button
              onClick={on45MinExtendDurationClick}
              className="px-4 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              45
            </button>
            <button
              onClick={on60MinExtendDurationClick}
              className="px-4 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              60
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
